<template>
  <div
    v-if="showCookieMessage"
    class="cookie"
  >
    <div class="cookie__text">
      {{ t("entities.cookie.text") }}

      <BaseLink
        :href="`/${locale}/about/cookie`"
        target="_blank"
      >
        {{ t("entities.cookie.link") }}
      </BaseLink>
      {{ t("entities.cookie.textDesc") }}
    </div>

    <BaseButton2
      class="base-button-small base-button-second cookie__button"
      @click="acceptCookies"
    >
      {{ t("entities.cookie.button") }}
    </BaseButton2>
  </div>
</template>

<script setup lang="ts">
const { t, locale } = useI18n();

const cookiesAccepted = useCookie("donut-cookies-accepted-main", {
  maxAge: 31536000,
});

const showCookieMessage = ref(!cookiesAccepted.value);

onMounted(() => {
  if (localStorage.getItem("donut-cookies-accepted-main") === "true") {
    showCookieMessage.value = false;
  }
});

const acceptCookies = () => {
  cookiesAccepted.value = "true";
  localStorage.setItem("donut-cookies-accepted-main", "true");
  showCookieMessage.value = false;
};
</script>

<style scoped>
.cookie {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: calc(var(--z-index-header) + 1);
  display: flex;
  align-items: center;
  width: 100%;
  padding: 7px 12px;
  font-size: 11px;
  color: var(--white);
  line-height: 1.33;
  letter-spacing: 0.1px;
  border-radius: 12px 12px 0 0;
  background-color: black;
  box-shadow: 0 4px 16px 0 #0000001f;
  column-gap: 16px;
}

.cookie__button {
  padding: 6px 12px;
  font-size: 11px;
  color: var(--white);
}

@media (--desktop) {
  .cookie__text {
    min-width: 568px;
    margin-bottom: 0;
  }

  .cookie {
    bottom: 40px;
    left: 40px;
    align-items: start;
    flex-direction: column;
    width: auto;
    padding: 22px 16px;
    font-size: 12px;
    color: var(--grey-1);
    line-height: 1.33;
    letter-spacing: 0.1px;
    border-radius: 12px;
    column-gap: 0;
    row-gap: 8px;
    background-color: var(--white);
  }

  .cookie__button {
    padding: 6px 20px;
    font-size: 14px;
    color: var(--orange-1);
  }
}

.cookie .cookie__text a {
  display: inline;
  color: var(--orange-1);
}

.cookie .cookie__text a:visited {
  color: var(--orange-1);
}
</style>
